export const animateLinks = (selector) => {
    const links = document.querySelectorAll(selector);
    links.forEach((link, index) => {
        setTimeout(() => {
            link.classList.add('animate-in');
        }, index * 100);
    });
};